exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-separator svg{width:100%;padding:0;display:block;position:relative;height:50px}@media screen and (min-width:959px){.section-separator svg{height:100px}}.section-separator.flip-vertical svg{-webkit-transform:scaleY(-1);transform:scaleY(-1)}.section-separator.flip-horizontal{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.section-separator.flip-both{-webkit-transform:scaleX(-1,-1);transform:scaleX(-1,-1)}", ""]);

// exports
